function timeFormate (timeStamp, type) {
  const year = new Date(timeStamp).getFullYear()
  const month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1
  const date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
  const hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours()
  const mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes()
  const ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds()
  let time = type && type == 1 ? (year + "-" + month + "-" + date + " " + hh + ":" + mm + ":" + ss) : (year + "-" + month + "-" + date)
  if (type == 3) {
    time = year + "-" + month + "-" + date + " " + hh + ":" + mm
  }
  return time
}

// 验证手机号
const checkPhone = function (phone) {
  return /^1[3-9]\d{9}$/.test(phone)
}

const checkIdNumber = function (idnum) {
  return /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(idnum)
}

// 去除字符串收尾空格，并将文本内多个空格替换成一个
const handleStrSpace = function (val) {
  if (typeof val === 'string') {
    val = val.trim()
    val = val.replace(/\s+/g, ' ')
  }
  return val
}
const getAge = function (str) {
  const r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})/); if (r == null) return false; const d = new Date(r[1], r[3] - 1, r[4]); let returnStr = "输入的日期格式错误！"; if (d.getFullYear() == r[1] && (d.getMonth() + 1) == r[3] && d.getDate() == r[4]) {
    const date = new Date(); const yearNow = date.getFullYear(); const monthNow = date.getMonth() + 1; const dayNow = date.getDate(); const largeMonths = [1, 3, 5, 7, 8, 10, 12] // 大月， 用于计算天，只在年月都为零时，天数有效
    const lastMonth = monthNow - 1 > 0 ? monthNow - 1 : 12 // 上一个月的月份
    let isLeapYear = false // 是否是闰年
    let daysOFMonth = 0 // 当前日期的上一个月多少天
    if ((yearNow % 4 === 0 && yearNow % 100 !== 0) || yearNow % 400 === 0) { // 是否闰年， 用于计算天，只在年月都为零时，天数有效
      isLeapYear = true
    }
    if (largeMonths.indexOf(lastMonth) > -1) { daysOFMonth = 31 } else if (lastMonth === 2) { if (isLeapYear) { daysOFMonth = 29 } else { daysOFMonth = 28 } } else { daysOFMonth = 30 } let Y = yearNow - parseInt(r[1]); let M = monthNow - parseInt(r[3]); let D = dayNow - parseInt(r[4]); if (D < 0) {
      D = D + daysOFMonth // 借一个月
      M--
    }
    if (M < 0) { // 借一年 12个月
      Y--; M = M + 12 //
    }
    if (Y < 0) {
      returnStr = "出生日期有误！"
    } else if (Y === 0) {
      if (M === 0) {
        returnStr = D + "D"
      } else {
        returnStr = M + "M"
      }
    } else {
      returnStr = Y
    }
  }
  return returnStr
}

const getChatTimeFormat = function (time) {
  const today = new Date(dateFormat(new Date(), 'yyyy/MM/dd'))
  const thisTime = today.getTime()
  if (thisTime - time < 0) {
    return dateFormat(new Date(time), 'hh:mm')
  } else if (thisTime - time < 24 * 60 * 60 * 1000) {
    return '昨天 ' + dateFormat(new Date(time), 'hh:mm')
  } else if (thisTime - time < 6 * 24 * 60 * 60 * 1000) {
    let week = new Date(time).getDay()
    switch (week) {
    case 0:
      week = '星期日'
      break
    case 1:
      week = '星期一'
      break
    case 2:
      week = '星期二'
      break
    case 3:
      week = '星期三'
      break
    case 4:
      week = '星期四'
      break
    case 5:
      week = '星期五'
      break
    case 6:
      week = '星期六'
      break
    }
    return week + ' ' + dateFormat(new Date(time), 'hh:mm')
  } else {
    return dateFormat(new Date(time), 'yy/MM/dd hh:mm')
  }
}
const dateFormat = function (date, fmt) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

const get_suffix = function (filename) {
  const pos = filename.lastIndexOf('.')
  let suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}
const random_string = function (len) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

const getRandomFileName = function (filename, len) {
  return random_string(len) + get_suffix(filename)
}

const formateTime = function (time) {
  const h = parseInt(time / 3600)
  const minute = parseInt(time / 60 % 60)
  const second = Math.ceil(time % 60)

  const hours = h < 10 ? '0' + h : h
  const formatSecond = second > 59 ? 59 : second
  return `${hours > 0 ? `${hours}时` : ''}${minute}分${formatSecond}秒`
}

/**
         *
         * @param dateNow :Date类
         * @param intervalDays ：间隔天数
         * @param bolPastTime  ：Boolean,判断在参数date之前，还是之后，
         */
const getDateRange = function (dateNow, intervalDays, bolPastTime) {
  const oneDayTime = 24 * 60 * 60 * 1000
  const list = []
  let lastDay

  if (bolPastTime == true) {
    lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime)
    list.push(this.formateDate(lastDay))
    list.push(this.formateDate(dateNow))
  } else {
    lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime)
    list.push(this.formateDate(dateNow))
    list.push(this.formateDate(lastDay))
  }
  return list
}
const formateDate = function (time) {
  const year = time.getFullYear()
  let month = time.getMonth() + 1
  let day = time.getDate()

  if (month < 10) {
    month = '0' + month
  }

  if (day < 10) {
    day = '0' + day
  }

  return year + '-' + month + '-' + day + ''
}

const getBirthByIdCard = function getBirthdayByIdCard (idCard) {
  if (idCard.length === 15) {
    return ['19' + idCard.substr(6, 2), idCard.substr(8, 2), idCard.substr(10, 2)].join('-')
  } else if (idCard.length === 18) {
    return [idCard.substr(6, 4), idCard.substr(10, 2), idCard.substr(12, 2)].join('-')
  }

  return ''
}

const getSexByIdCard = function getSexByIdCard (idCard) {
  if (idCard.length === 15) {
    return [2, 1][idCard.substr(14, 1) % 2]
  } else if (idCard.length === 18) {
    return [2, 1][idCard.substr(16, 1) % 2]
  }

  return ''
}

const getAgeByIdCard = function getAgeByIdCard (idCard) {
  const sexAndAge = {}
  // 获取用户身份证号码
  const userCard = idCard
  // 如果用户身份证号码为undefined则返回空
  if (!userCard) {
    return sexAndAge
  }
  // 获取出生日期
  const yearBirth = userCard.substring(6, 10)
  const monthBirth = userCard.substring(10, 12)
  const dayBirth = userCard.substring(12, 14)
  // 获取当前年月日并计算年龄
  const myDate = new Date()
  const monthNow = myDate.getMonth() + 1
  const dayNow = myDate.getDate()
  let age = myDate.getFullYear() - yearBirth
  if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
    age--
  }
  // 得到年龄
  sexAndAge.age = age
  return sexAndAge.age
}

const imageExts = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.heic']

function isImage (url) {
  let path = ''
  if (url.indexOf('?') > -1) {
    path = url.substring(0, url.indexOf('?')).toLowerCase()
  } else {
    path = url.toLowerCase()
  }
  let isImage = false
  Object.keys(imageExts).forEach(key => {
    if (path.endsWith(imageExts[key])) {
      isImage = true
    }
  })
  return isImage
}

const videoExts = ['.mov', '.mp4', '.avi', '.3gp', '.wmv', '.flv', '.mkv', '.rmvb']

function isVideo (url) {
  let path = ''
  if (url.indexOf('?') > -1) {
    path = url.substring(0, url.indexOf('?')).toLowerCase()
  } else {
    path = url.toLowerCase()
  }
  let isVideo = false
  Object.keys(videoExts).forEach(key => {
    if (path.endsWith(videoExts[key])) {
      isVideo = true
    }
  })
  return isVideo
}

function formatNull (value, defaultValue = '') {
  if (value == null || value == 'null' || value == 'undefined' || value == undefined) {
    return defaultValue
  } else if (value instanceof String) {
    return value
  } else {
    return String(value)
  }
}

function deepCopy (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function getPhonePlatFormByBrand (brand) {
  if (!brand) {
    return 0
  }
  let iOSBrands = ['苹果', 'iphone', 'ios', 'ipad', 'apple', 'ipods', 'mac']
  let iOSIndex = iOSBrands.findIndex(item => brand.toLowerCase().indexOf(item) > -1)
  let isIOS = iOSIndex > -1
  return isIOS ? 1 : 2
}

function limitDecimal(val, scale = 2) {
  // 1. 只保留数字和小数点，^ 在 [] 里表示“取反”
  val = val.replace(/[^\d.]/g, '')
  // 2. 只能有一个小数点
  // 连续输入小数点2个及以上改为1个
  val = val.replace(/\.{2,}/g, '.')
  // 多个间隔小数点只保留第一个
  val = val
    // 第一个小数点替换为特殊符号，暂存
    .replace('.', '$#$')
    // 删除剩余小数点
    .replace(/\./g, '')
    // 还原第一个小数点
    .replace('$#$', '.')
  // 3. 限制小数点后最多scale位
  // val = val.replace(/^(\d+)(\.\d{0,2}).*$/, '$1$2')
  const reg = new RegExp(`^(\\d+)(\\.\\d{0,${scale}}).*`)
  val = val.replace(reg, '$1$2')
  // 4. 开头小数点的要补 .x → 0.x
  if (val.startsWith('.')) {
    val = '0' + val
  }
  // 5.不要小数的，小数点也不要了
  if (scale === 0) {
    val = val.replace('.', '')
  }
  return val
}

function isEmpty (str) {
  return str === null || str === undefined || str === ''
}

function getWebUrl (name) {
  return 'https://sj-credit.oss-cn-shanghai.aliyuncs.com/app/notice/' + name
}

export default {
  timeFormate,
  checkPhone,
  checkIdNumber,
  handleStrSpace,
  getAge,
  getChatTimeFormat,
  get_suffix,
  random_string,
  formateTime,
  getDateRange,
  formateDate,
  getBirthByIdCard,
  getAgeByIdCard,
  getSexByIdCard,
  isImage,
  isVideo,
  imageExts,
  videoExts,
  formatNull,
  getRandomFileName,
  deepCopy,
  getPhonePlatFormByBrand,
  limitDecimal,
  isEmpty,
  getWebUrl
}
